// @flow
import * as React from 'react';
import BrandEngageCard from 'components/BrandEngageCard/BrandEngageCard';
import { ResponseTextBox } from 'components/Common';
import { QAItemIcon } from 'components/ContentSection/QASection';
import { SimpleResponse } from 'components/ContentSection/ReviewResponse';
import { Review, UGC } from 'models';
import Observation from 'models/Observation';
import { Set } from 'immutable';

type BrandEngageContainerState = {
  responseValue: string,
  responseStatus: ?RequestStatus,
};

type BrandEngageContainerProps = {
  clientId: Id,
  ugc: *,
  product: *,
  brandCatalogId: *,
  status: ?RequestStatus,
  requestBrandEngageAddResponse: Function,
  requestBrandEngageDismissContent: Function,
  brandEngageResponseStatus: ?RequestStatus,
  dismissRequestStatus: ?RequestStatus,
  observations: Set<string>,
  readonly?: boolean,
};

class Container extends React.Component<
  BrandEngageContainerProps,
  BrandEngageContainerState
> {
  state = {
    responseValue: '',
    responseStatus: null,
  };

  handleChange = (nextState: BrandEngageContainerState) => {
    if (!this.state.pending) {
      this.setState(nextState);
    }
  };

  handleResponseSubmit = () => {
    const addPayload = {
      brand_catalog_id: this.props.brandCatalogId,
      parent_ugc_id: this.props.ugc.ugc_id,
      subject_id: this.props.product.subject_id,
      catalog_id: this.props.product.merchant.id,
      text: this.state.responseValue,
      ugc_type:
        this.props.ugc.ugc_archetype === 'Review'
          ? 'BrandMerchantResponse'
          : 'BrandAnswer',
      locale: 'en_US',
    };
    this.props.requestBrandEngageAddResponse(addPayload, this.props.ugc.ugc_id);
  };

  handleResponseChange = (value: string) =>
    this.setState({
      responseValue: value,
    });

  handleDismiss = () => {
    const dismissPayload = {
      ugc_id: this.props.ugc.ugc_id,
      clientId: this.props.clientId,
      observationPayload: [
        {
          catalog_id: this.props.product.merchant.id,
          observation_type_code: Observation.BrandEngaged,
          observation_data: { comments: '' },
          client_id: this.props.product.merchant.group_id,
        },
      ],
    };
    this.props.requestBrandEngageDismissContent(
      dismissPayload,
      this.props.ugc.ugc_id
    );
  };

  render() {
    const { ugc, readonly } = this.props;
    let placeholder;
    let buttonLabel;
    const hideTextBox =
      readonly === true ||
      UGC.hasBrandResponseOrAnswer(ugc) ||
      ugc.ugc_archetype === 'Answer' ||
      ugc.ugc_archetype === 'MerchantResponse';

    if (this.props.ugc.ugc_archetype === 'Question') {
      buttonLabel = 'Add Answer';
      placeholder = 'Add a brand answer to this question...';
    } else if (this.props.ugc.ugc_archetype === 'Review') {
      buttonLabel = 'Add Response';
      placeholder = 'Add a brand response to this review...';
    }

    return (
      <BrandEngageCard {...this.props} onDismiss={this.handleDismiss}>
        {renderBrandResponse(this.props.ugc)}
        {!hideTextBox && (
          <div className="flex flex-row">
            {this.props.ugc.ugc_archetype === 'Question' && (
              <QAItemIcon ugctype="Answer" />
            )}
            <div className="flex-auto">
              <ResponseTextBox
                name="response"
                placeholder={placeholder}
                buttonLabel={buttonLabel}
                value={this.state.responseValue}
                onChange={this.handleResponseChange}
                onSubmit={this.handleResponseSubmit}
                status={this.props.brandEngageResponseStatus}
              />
            </div>
          </div>
        )}
      </BrandEngageCard>
    );
  }
}

function renderBrandResponse(ugc: Ugc) {
  if (ugc instanceof Review) {
    const brandResponse = ugc.getBrandResponse();
    if (brandResponse) {
      return <SimpleResponse ugc={brandResponse} />;
    }

    return null;
  }
}

export default Container;



// WEBPACK FOOTER //
// ./src/containers/brand-engage/BrandEngageCardContainer.js